import { FC } from 'react';

import { Loader } from 'components';
import useTimeZone from 'hooks/use-timezone';
import { useEditTransaction } from './edit-transaction.context';

const EditGeneral: FC = () => {
  const { transaction, setTransaction } = useEditTransaction();
  const { dateTimeLocalToUtc, newZonedDayJs, utcToZonedDateTimeLocal } = useTimeZone();

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>GENERAL INFORMATION</h4>
      </div>
      <div className="card-body">
        <Loader loading={transaction === undefined}>
          <div className="grid-4 p-2">
            <div>
              <h6 className="text-info-dark">TYPE</h6>
              <input
                type="text"
                className="mt-2 w-100"
                value={!transaction?.inbound ? 'GATE OUT' : 'GATE IN'}
                disabled
              />
            </div>
            <div>
              <h6 className="text-info-dark">DATE</h6>
              <input
                type="datetime-local"
                className="mt-2 w-100"
                value={utcToZonedDateTimeLocal(transaction?.completedDate)}
                onChange={e => {
                  setTransaction(t => t && { ...t, completedDate: dateTimeLocalToUtc(e.target.value) });
                  if (newZonedDayJs(e.target.value).isAfter(newZonedDayJs())) {
                    e.target.setCustomValidity('Forward dated transactions are not allowed');
                  } else {
                    e.target.setCustomValidity('');
                  }
                }}
                data-cy="edit-transaction-date-input"
              />
            </div>
            <div className="col-span-2 row-span-2 h-100 d-flex flex-column">
              <h6 className="text-info-dark">NOTES</h6>
              <textarea
                className="mt-2 w-100 flex-fill"
                value={transaction?.notes ?? ''}
                onChange={e => setTransaction(t => t && { ...t, notes: e.target.value })}
                data-cy="edit-transaction-notes-input"
              />
            </div>
          </div>
        </Loader>
      </div>
    </div>
  );
};

export default EditGeneral;
